import { NOVEL_COLLECTION } from 'redux/constant/novelCollection'
import { createListSlice } from 'redux/utils'

const slice = createListSlice(NOVEL_COLLECTION)
export const { actions } = slice
export default slice.reducer
